module.exports = __webpack_public_path__ + "img/7_83.7d12a9a7.png";